import React from 'react';
import Grid from '@material-ui/core/Grid';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import Card from 'src/components/sharedComponents/Card/Card';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';

const UsersCreator = ({
  onCreate, onChange, user, error,
}) => {
  const mensaje = 'La contraseña debe tener al menos 8 caracteres';
  return (
    <>
      <div>
        <CardTitle title="Cree un Usuario" />
        <div style={{ margin: '10px' }}>
          <Grid justifyContent="center" container spacing={2}>
            <Grid item xs={12} md={6} sm={8}>
              <form onSubmit={onCreate}>
                <Card>
                  <CardHeader color="customAuteco" stats icon>
                    <CardIcon color="customAuteco">
                      <ContactMailIcon />
                    </CardIcon>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="Nombre"
                      id="name"
                      value={user.nombre}
                      required
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}
                      inputProps={{
                        onChange: (event) => onChange(event, 'nombre'),
                        type: 'text',
                        autoComplete: 'off',
                        rows: 5,
                      }}
                    />
                    <CustomInput
                      labelText="Apellido"
                      id="lastname"
                      value={user.apellido}
                      required
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}
                      inputProps={{
                        onChange: (event) => onChange(event, 'apellido'),
                        type: 'text',
                        autoComplete: 'off',
                      }}
                    />
                    <CustomInput
                      labelText="Correo"
                      id="correo"
                      value={user.correo}
                      required
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}
                      inputProps={{
                        onChange: (event) => onChange(event, 'correo'),
                        type: 'email',
                        // autoComplete: 'off',
                      }}
                    />
                    <CustomInput
                      labelText="Contraseña"
                      id="password"
                      value={user.clave}
                      error={error.error}
                      success={error.success}
                      required
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}
                      inputProps={{
                        type: 'text',
                        onChange: (event) => onChange(event, 'clave'),
                        autoComplete: 'off',
                      }}
                    />
                    {error?.error && <p>{mensaje}</p>}
                  </CardBody>
                  <CardFooter>
                    <Button type="onSubmit " color="warning">
                      Crear Usuario
                    </Button>
                  </CardFooter>
                </Card>
              </form>
              <div />
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default UsersCreator;
